<template>
  <div class="view-sticky-footer">
    <cms-sticky-footer
      v-if="stickyFooterSetUp"
      :theme="stickyFooterOptions"
      :content="homepage.sticky_footer"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const theme = computed(() => store.state.theme);
const homepage = computed(() => store.state.homepage);

const stickyFooterOptions = computed(() => ({
  ...theme.value.sticky_footer.options,
  translations: store.getters['translation/getComponentTranslation']('sticky_footer'),
  globalThemeSettings: store.getters.getGlobalThemeSettings,
}));

const stickyFooterSetUp = computed(
  () => homepage.value?.sticky_footer?.pill_button || homepage.value?.sticky_footer?.icon_buttons,
);
</script>
